import { red } from '@mui/material/colors';
import { Color, ThemeOptions } from '@mui/material';

const skyBlue: Color = {
  50: '#e4fafd',
  100: '#bdf2fa',
  200: '#91e9f7',
  300: '#64e0f3',
  400: '#43daf1',
  500: '#22d3ee',
  600: '#1eceec',
  700: '#19c8e9',
  800: '#14c2e7',
  900: '#0cb7e2',
  A100: '#ffffff',
  A200: '#daf7ff',
  A400: '#a7ecff',
  A700: '#8de6ff',
};
const themePreset = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    text: {
      primary: 'rgb(17, 24, 39)',
      secondary: 'rgb(107, 114, 128)',
      disabled: 'rgb(149, 156, 169)',
    },
    common: {
      black: 'rgb(17, 24, 39)',
      white: 'rgb(255, 255, 255)',
    },
    primary: {
      50: '#e5e6e8',
      100: '#bec1c5',
      200: '#92979f',
      300: '#666d78',
      400: '#464e5b',
      500: '#252f3e',
      600: '#212a38',
      700: '#1b2330',
      800: '#161d28',
      900: '#0d121b',
      A100: '#5d8eff',
      A200: '#2a6aff',
      A400: '#004af6',
      A700: '#0042dd',
    },
    secondary: {
      light: skyBlue[100],
      main: skyBlue[500],
      dark: skyBlue[900],
    },
    background: {
      paper: '#FFFFFF',
      default: '#f6f7f9',
    },
    error: red,
  },
  typography: {
    fontSize: 13,
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.4,
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.35,
    },
    subtitle1: {
      fontSize: '1rem',
      lineHeight: 1.35,
    },
    h5: {
      fontSize: '1.25rem',
      lineHeight: 1.25,
    },
    h6: {
      fontSize: '1rem',
      lineHeight: 1.3,
    },
    button: {
      fontSize: '0.8125rem',
    },
    fontFamily: ['Inter', 'Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(','),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  components: {
    MuiCard: {
      // styleOverrides: {
      //   root: {
      //     boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      //   },
      // },
    },
    MuiAppBar: {
      // defaultProps: {
      //   enableColorOnDark: true,
      // },
      // styleOverrides: {
      //   root: {
      //     backgroundImage: 'none',
      //   },
      // },
    },
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
          minHeight: '2rem',
          paddingInline: '0.625rem',
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          padding: '0.375rem',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
        },
        input: {
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: '2rem',
          fontSize: '0.875rem',
        },
      },
    },
    MuiButtonGroup: {
      // styleOverrides: {
      //   contained: {
      //     borderRadius: 18,
      //   },
      // },
    },
    MuiTab: {
      // styleOverrides: {
      //   root: {
      //     textTransform: 'none',
      //   },
      // },
    },
    MuiDialog: {
      // styleOverrides: {
      //   paper: {
      //     borderRadius: 16,
      //   },
      // },
    },
    MuiPaper: {
      // styleOverrides: {
      //   rounded: {
      //     borderRadius: 16,
      //   },
      // },
    },
    MuiPopover: {
      // styleOverrides: {
      //   paper: {
      //     borderRadius: 8,
      //   },
      // },
    },
    MuiFilledInput: {
      // styleOverrides: {
      //   root: {
      //     borderRadius: 4,
      //     '&:before, &:after': {
      //       display: 'none',
      //     },
      //   },
      // },
    },
    MuiSlider: {
      // defaultProps: {
      //   color: 'secondary',
      // },
    },
    MuiCheckbox: {
      // defaultProps: {
      //   color: 'secondary',
      // },
    },
    MuiRadio: {
      // defaultProps: {
      //   color: 'secondary',
      // },
    },
    MuiSwitch: {
      // defaultProps: {
      //   color: 'secondary',
      // },
    },
    MuiAccordion: {
      // styleOverrides: {
      //   root: {
      //     borderRadius: 8,
      //     '&:first-of-type, &:last-of-type': {
      //       borderRadius: 8,
      //     },
      //   },
      // },
    },
    MuiCalendarPicker: {
      // styleOverrides: {
      //   root: {
      //     '& .PrivatePickersFadeTransitionGroup-root > div': {
      //       whiteSpace: 'nowrap',
      //       fontSize: '0.95rem',
      //       '@media (max-width: 768px)': {
      //         fontSize: '0.8rem',
      //       },
      //     },
      //   },
      // },
    },
  },
} as ThemeOptions;

export default themePreset;
